import { createSlice } from '@reduxjs/toolkit'

export const plansSlice = createSlice({
  name: 'plans',
  initialState: {
    flowType: 'default',
    plan: '',
    planDetails: null,
    couponDetails: null,
  },
  reducers: {
    setFlowType: (state, action) => {
      if (action.payload) {
        state.flowType = action.payload
      }
    },
    setPlan: (state, action) => {
      state.plan = action.payload
    },
    setPlanDetails: (state, action) => {
      state.planDetails = action.payload
    },
    setCouponDetails: (state, action) => {
      state.couponDetails = action.payload
    },
  },
})

export const { setPlan, setFlowType, setPlanDetails, setCouponDetails } = plansSlice.actions

export const selectPlan = (state: any) => state.plans.plan
export const selectFlowType = (state: any) => state.plans.flowType
export const selectPlanDetails = (state: any) => state.plans.planDetails
export const selectPlanCoupon = (state: any) => state.plans.couponDetails

export default plansSlice.reducer
